namespace RioERP.Products {
    export interface PacksRow {
        Id?: number;
        PackName?: string;
        Tags?: string;
    }

    export namespace PacksRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Tags';
        export const localTextPrefix = 'Products.Packs';
        export const lookupKey = 'Products.Packs';

        export function getLookup(): Q.Lookup<PacksRow> {
            return Q.getLookup<PacksRow>('Products.Packs');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            PackName = "PackName",
            Tags = "Tags"
        }
    }
}
